import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "@/context/AuthContext";
import { CircularProgress, Box, Typography } from "@mui/material";

export const Logout = () => {
  const { signOut }: any = useAuthContext();
  const navigate = useNavigate();
  const [loggingOut, setLoggingOut] = useState(true);

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await signOut();
        navigate("/");
      } catch (error) {
        console.error("Error logging out:", error);
        setLoggingOut(false);
      }
    };

    handleLogout();
  }, [signOut, navigate]);

  if (loggingOut) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress sx={{ mb: 2 }} />
        <Typography variant="body1">Logging out...</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Typography variant="h6" color="error" sx={{ mb: 2 }}>
        Error logging out.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Please try again or close your browser to complete the logout process.
      </Typography>
      <button onClick={() => navigate("/")}>Return to login</button>
    </Box>
  );
};
